import { render } from "./FlashMessages.vue?vue&type=template&id=4b5eb2d4"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/karsten/Dropbox (Privat)/htdocs/wintitower/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__